var _path, _g, _rect, _rect2, _rect3, _g2, _circle, _path2, _path3, _rect4, _rect5, _rect6, _rect7, _rect8, _g3, _circle2, _path4, _path5, _rect9, _rect10, _g4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSignupwallpaper = function SvgSignupwallpaper(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 445,
    height: 791,
    viewBox: "0 0 445 791",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_63_1271",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 445,
    height: 791
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H445V791H0V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_63_1271)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter0_f_63_1271)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M283.672 -2.26266C341.141 110.811 300.292 246.914 192.432 301.734C84.5722 356.553 80.9906 243.031 23.5217 129.958C-33.9473 16.8844 -123.541 -52.922 -15.6816 -107.741C92.1781 -162.56 226.203 -115.336 283.672 -2.26266Z",
    fill: "#FFD600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.672 347.737C651.141 460.811 610.292 596.914 502.432 651.733C394.572 706.553 390.991 593.031 333.522 479.958C276.053 366.884 186.459 297.078 294.318 242.259C402.178 187.44 536.203 234.664 593.672 347.737Z",
    fill: "#FFD600"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 233,
    cy: 406,
    r: 248,
    fill: "#76C6FF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 233,
    cy: 986,
    r: 248,
    fill: "#76C6FF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 651,
    cy: 564,
    r: 248,
    fill: "#FFCD00",
    fillOpacity: 0.5
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -170.298,
    y: 374.106,
    width: 485.952,
    height: 121,
    rx: 7.5,
    transform: "rotate(-38 -170.298 374.106)",
    fill: "white",
    fillOpacity: 0.3,
    stroke: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 31.6785,
    y: 216.319,
    width: 229.653,
    height: 121.041,
    rx: 8.5,
    transform: "rotate(-38 31.6785 216.319)",
    fill: "white",
    fillOpacity: 0.1,
    stroke: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_63_1271",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 35,
    y: 77,
    width: 250,
    height: 232
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 32.4792,
    y: 215.719,
    width: 228.64,
    height: 121.075,
    rx: 7.5,
    transform: "rotate(-38 32.4792 215.719)",
    fill: "white",
    stroke: "black"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_63_1271)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_63_1271)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 92.2774,
    cy: 257.473,
    rx: 73.7988,
    ry: 82.5,
    transform: "rotate(-38 92.2774 257.473)",
    fill: "white",
    fillOpacity: 0.6
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_63_1271)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 264.843,
    cy: 274.932,
    rx: 73.7988,
    ry: 82.5,
    transform: "rotate(-38 264.843 274.932)",
    fill: "white",
    fillOpacity: 0.6
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_63_1271)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 204.678,
    cy: 104.935,
    rx: 73.7988,
    ry: 104.5,
    transform: "rotate(-38 204.678 104.935)",
    fill: "white",
    fillOpacity: 0.6
  })), /*#__PURE__*/React.createElement("rect", {
    x: 98.5435,
    y: 275.102,
    width: 68,
    height: 6,
    rx: 3,
    transform: "rotate(-38 98.5435 275.102)",
    fill: "url(#paint0_linear_63_1271)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.009,
    y: 285.937,
    width: 85,
    height: 6,
    rx: 3,
    transform: "rotate(-38 107.009 285.937)",
    fill: "url(#paint1_linear_63_1271)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 187.589,
    y: 205.532,
    width: 68,
    height: 6,
    rx: 3,
    transform: "rotate(-38 187.589 205.532)",
    fill: "url(#paint2_linear_63_1271)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196.054,
    y: 216.368,
    width: 85,
    height: 6,
    rx: 3,
    transform: "rotate(-38 196.054 216.368)",
    fill: "url(#paint3_linear_63_1271)"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 80.5596,
    cy: 222.847,
    r: 18,
    transform: "rotate(-38 80.5596 222.847)",
    fill: "url(#paint4_linear_63_1271)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M75.4293 216.28C73.7088 217.624 73.4029 220.116 74.7471 221.836C76.0656 223.524 78.4527 223.858 80.2193 222.573C80.2667 222.526 80.3193 222.485 80.3638 222.46C80.3769 222.45 80.3835 222.445 80.3966 222.435C80.4032 222.43 80.4032 222.43 80.4098 222.425C82.0447 221.052 82.2974 218.655 80.9855 216.962C79.6413 215.242 77.1498 214.936 75.4293 216.28Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M84.9988 221.652C82.2124 221.862 79.2246 224.197 78.3336 226.86C77.9357 228.069 78.066 229.184 78.6971 229.991C79.3281 230.799 80.3727 231.189 81.6311 231.094C83.0327 230.993 84.4821 230.357 85.6904 229.413C86.8987 228.469 87.8658 227.217 88.3029 225.881C88.6942 224.677 88.569 223.569 87.9328 222.755C87.2952 221.952 86.2572 221.557 84.9988 221.652Z",
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 98.1973,
    y: 196.694,
    width: 68,
    height: 6,
    rx: 3,
    transform: "rotate(-38 98.1973 196.694)",
    fill: "url(#paint5_linear_63_1271)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 106.509,
    y: 207.332,
    width: 108,
    height: 6,
    rx: 3,
    transform: "rotate(-38 106.509 207.332)",
    fill: "url(#paint6_linear_63_1271)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 518.596,
    y: 660.529,
    width: 485.952,
    height: 121,
    rx: 7.5,
    transform: "rotate(-128 518.596 660.529)",
    fill: "white",
    fillOpacity: 0.3,
    stroke: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 314.5,
    y: 202.9,
    width: 229.653,
    height: 121.041,
    rx: 8.5,
    transform: "rotate(52.1181 314.5 202.9)",
    fill: "white",
    fillOpacity: 0.1,
    stroke: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_63_1271",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 222,
    y: 206,
    width: 231,
    height: 250
  }, _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 315.098,
    y: 203.702,
    width: 228.64,
    height: 121.075,
    rx: 7.5,
    transform: "rotate(52.1181 315.098 203.702)",
    fill: "white",
    stroke: "black"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_63_1271)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_63_1271)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 273.222,
    cy: 263.414,
    rx: 73.7988,
    ry: 82.5,
    transform: "rotate(52.1181 273.222 263.414)",
    fill: "white",
    fillOpacity: 0.6
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_63_1271)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 255.407,
    cy: 435.943,
    rx: 73.7988,
    ry: 82.5,
    transform: "rotate(52.1181 255.407 435.943)",
    fill: "white",
    fillOpacity: 0.6
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_f_63_1271)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 425.527,
    cy: 376.129,
    rx: 73.7988,
    ry: 104.5,
    transform: "rotate(52.1181 425.527 376.129)",
    fill: "white",
    fillOpacity: 0.6
  })), /*#__PURE__*/React.createElement("rect", {
    x: 255.58,
    y: 269.643,
    width: 68,
    height: 6,
    rx: 3,
    transform: "rotate(52.1181 255.58 269.643)",
    fill: "url(#paint7_linear_63_1271)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244.727,
    y: 278.086,
    width: 85,
    height: 6,
    rx: 3,
    transform: "rotate(52.1181 244.727 278.086)",
    fill: "url(#paint8_linear_63_1271)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 324.966,
    y: 358.832,
    width: 68,
    height: 6,
    rx: 3,
    transform: "rotate(52.1181 324.966 358.832)",
    fill: "url(#paint9_linear_63_1271)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 314.113,
    y: 367.275,
    width: 85,
    height: 6,
    rx: 3,
    transform: "rotate(52.1181 314.113 367.275)",
    fill: "url(#paint10_linear_63_1271)"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 307.872,
    cy: 251.767,
    r: 18,
    transform: "rotate(52.1181 307.872 251.767)",
    fill: "url(#paint11_linear_63_1271)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M314.45 246.65C313.109 244.927 310.618 244.616 308.895 245.957C307.204 247.272 306.865 249.658 308.146 251.427C308.194 251.475 308.235 251.527 308.259 251.572C308.269 251.585 308.274 251.592 308.284 251.605C308.29 251.611 308.29 251.611 308.295 251.618C309.664 253.256 312.06 253.513 313.756 252.205C315.479 250.864 315.79 248.373 314.45 246.65Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M309.057 256.209C308.853 253.422 306.525 250.429 303.863 249.533C302.655 249.132 301.54 249.26 300.731 249.89C299.922 250.519 299.53 251.563 299.623 252.821C299.721 254.223 300.353 255.674 301.295 256.884C302.236 258.094 303.487 259.064 304.821 259.504C306.025 259.898 307.133 259.775 307.949 259.14C308.753 258.504 309.149 257.467 309.057 256.209Z",
    fill: "white"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 333.989,
    y: 269.459,
    width: 68,
    height: 6,
    rx: 3,
    transform: "rotate(52.1181 333.989 269.459)",
    fill: "url(#paint12_linear_63_1271)"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 323.333,
    y: 277.748,
    width: 108,
    height: 6,
    rx: 3,
    transform: "rotate(52.1181 323.333 277.748)",
    fill: "url(#paint13_linear_63_1271)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_63_1271)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 24,
    y: 46,
    fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
    fontSize: 22,
    fontWeight: 900,
    fill: "#131F32",
    letterSpacing: -1
  }, "datascient.ai"), /*#__PURE__*/React.createElement("circle", {
    cx: 160,
    cy: 40,
    r: 5,
    fill: "#FFD600"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_63_1271",
    x: -366.245,
    y: -586,
    width: 2235.95,
    height: 2120,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 150,
    result: "effect1_foregroundBlur_63_1271"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_63_1271",
    x: -14.936,
    y: 148.151,
    width: 214.427,
    height: 218.642,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15,
    result: "effect1_foregroundBlur_63_1271"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_63_1271",
    x: 157.629,
    y: 165.611,
    width: 214.427,
    height: 218.642,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15,
    result: "effect1_foregroundBlur_63_1271"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_63_1271",
    x: 77.9531,
    y: -29.1319,
    width: 253.45,
    height: 268.135,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20,
    result: "effect1_foregroundBlur_63_1271"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_63_1271",
    x: 163.884,
    y: 156.218,
    width: 218.677,
    height: 214.392,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15,
    result: "effect1_foregroundBlur_63_1271"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_63_1271",
    x: 146.069,
    y: 328.747,
    width: 218.677,
    height: 214.392,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15,
    result: "effect1_foregroundBlur_63_1271"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_63_1271",
    x: 291.401,
    y: 249.467,
    width: 268.251,
    height: 253.324,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20,
    result: "effect1_foregroundBlur_63_1271"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_63_1271",
    x1: 104.043,
    y1: 278.102,
    x2: 166.543,
    y2: 281.102,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4E5F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4E6BE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_63_1271",
    x1: 113.884,
    y1: 288.937,
    x2: 191.908,
    y2: 293.619,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4E5F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4E6BE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_63_1271",
    x1: 193.089,
    y1: 208.532,
    x2: 255.589,
    y2: 211.532,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4E5F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4E6BE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_63_1271",
    x1: 202.929,
    y1: 219.368,
    x2: 280.953,
    y2: 224.049,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4E5F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4E6BE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_63_1271",
    x1: 66.5596,
    y1: 208.847,
    x2: 92.0596,
    y2: 242.847,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2E5FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBE7B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_63_1271",
    x1: 103.697,
    y1: 199.694,
    x2: 166.197,
    y2: 202.694,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4E5F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4E6BE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_63_1271",
    x1: 115.244,
    y1: 210.332,
    x2: 214.163,
    y2: 217.873,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4E5F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4E6BE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_63_1271",
    x1: 261.08,
    y1: 272.643,
    x2: 323.58,
    y2: 275.643,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4E5F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4E6BE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_63_1271",
    x1: 251.602,
    y1: 281.086,
    x2: 329.626,
    y2: 285.768,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4E5F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4E6BE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_63_1271",
    x1: 330.466,
    y1: 361.832,
    x2: 392.966,
    y2: 364.832,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4E5F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4E6BE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_63_1271",
    x1: 320.988,
    y1: 370.275,
    x2: 399.012,
    y2: 374.956,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4E5F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4E6BE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_63_1271",
    x1: 293.872,
    y1: 237.767,
    x2: 319.372,
    y2: 271.767,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2E5FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBE7B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_63_1271",
    x1: 339.489,
    y1: 272.459,
    x2: 401.989,
    y2: 275.459,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4E5F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4E6BE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_63_1271",
    x1: 332.069,
    y1: 280.748,
    x2: 430.987,
    y2: 288.289,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4E5F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4E6BE"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_63_1271"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 32,
    fill: "white",
    transform: "translate(24 24)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSignupwallpaper);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "signupwallpaper.d32a21a1e2de36110bbdc93489433e1e.svg";